module.exports = __webpack_public_path__ + "img/SDG-08-EN.96e60cd3.png";